import template from './swag-cms-extensions-form-editor-empty-state.html.twig';
import './swag-cms-extensions-form-editor-empty-state.scss';

export default {
    template,
    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    },
    methods: {
        onStartEditor() {
            this.$emit('start-editor');
        },
    },
}
